import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/castor.png'


const _hoisted_1 = { class: "ia-shell" }
const _hoisted_2 = { class: "ia-history-search" }
const _hoisted_3 = { class: "ia-history-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "ia-history-text" }
const _hoisted_6 = { class: "ia-history-title" }
const _hoisted_7 = { class: "ia-history-meta" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "ia-history-empty"
}
const _hoisted_10 = { class: "ia-trash-section" }
const _hoisted_11 = {
  key: 0,
  class: "ia-trash-count"
}
const _hoisted_12 = {
  key: 0,
  class: "ia-trash-list"
}
const _hoisted_13 = {
  key: 0,
  class: "ia-history-empty"
}
const _hoisted_14 = { class: "ia-trash-item-title" }
const _hoisted_15 = { class: "ia-trash-item-meta" }
const _hoisted_16 = { class: "ia-trash-item-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "ia-stt-config" }
const _hoisted_20 = {
  key: 0,
  class: "ia-stt-warn"
}
const _hoisted_21 = { class: "ia-left" }
const _hoisted_22 = { class: "ia-body-wrap" }
const _hoisted_23 = {
  key: 0,
  class: "ia-fade ia-fade--top"
}
const _hoisted_24 = { class: "offline-report-form" }
const _hoisted_25 = { class: "offline-report-field" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "offline-report-field" }
const _hoisted_28 = {
  key: 0,
  class: "offline-report-error"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_31 = {
  key: 1,
  class: "ia-loading-dot"
}
const _hoisted_32 = { class: "ia-hero-suggestions" }
const _hoisted_33 = {
  key: 1,
  class: "ia-messages"
}
const _hoisted_34 = { class: "ia-msg-body" }
const _hoisted_35 = { class: "ia-msg-text" }
const _hoisted_36 = {
  key: 1,
  class: "ia-user-bubble"
}
const _hoisted_37 = {
  key: 0,
  class: "ia-msg ia-msg--assistant"
}
const _hoisted_38 = {
  key: 1,
  class: "ia-fade ia-fade--bottom"
}
const _hoisted_39 = { class: "ia-input-area" }
const _hoisted_40 = {
  key: 0,
  class: "ia-action-bar"
}
const _hoisted_41 = {
  key: 1,
  class: "ia-action-bar"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 2,
  class: "ia-action-bar"
}
const _hoisted_45 = {
  key: 3,
  class: "ia-question-bar"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 4,
  class: "ia-input-wrap"
}
const _hoisted_48 = ["title"]
const _hoisted_49 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_50 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_51 = ["placeholder", "disabled"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "ia-attachments"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "ia-recording-bar"
}
const _hoisted_56 = {
  key: 0,
  class: "ia-side-panel"
}
const _hoisted_57 = { class: "ia-panel-header" }
const _hoisted_58 = { class: "ia-panel-body" }
const _hoisted_59 = { class: "ia-panel-field" }
const _hoisted_60 = { class: "ia-panel-value" }
const _hoisted_61 = { class: "ia-panel-row" }
const _hoisted_62 = { class: "ia-panel-field" }
const _hoisted_63 = { class: "ia-panel-value" }
const _hoisted_64 = { class: "ia-panel-field" }
const _hoisted_65 = { class: "ia-panel-value" }
const _hoisted_66 = {
  key: 0,
  class: "ia-panel-field"
}
const _hoisted_67 = { class: "ia-panel-value" }
const _hoisted_68 = {
  key: 1,
  class: "ia-panel-field"
}
const _hoisted_69 = { class: "ia-panel-tags" }
const _hoisted_70 = {
  key: 2,
  class: "ia-panel-field"
}
const _hoisted_71 = { class: "ia-panel-list" }
const _hoisted_72 = {
  key: 3,
  class: "ia-panel-field"
}
const _hoisted_73 = { class: "ia-panel-list" }
const _hoisted_74 = {
  key: 4,
  class: "ia-panel-field"
}
const _hoisted_75 = { class: "ia-panel-list" }
const _hoisted_76 = { class: "ia-panel-author" }
const _hoisted_77 = {
  key: 1,
  class: "ia-side-panel"
}
const _hoisted_78 = { class: "ia-panel-header" }
const _hoisted_79 = { class: "ia-panel-body" }
const _hoisted_80 = { class: "ia-panel-field" }
const _hoisted_81 = { class: "ia-panel-value" }
const _hoisted_82 = { class: "ia-panel-label" }
const _hoisted_83 = {
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"vertical-align":"-1px","margin-right":"4px"}
}
const _hoisted_84 = { class: "ia-gantt-task-title" }
const _hoisted_85 = { class: "ia-gantt-task-meta" }
const _hoisted_86 = { class: "ia-gantt-chip" }
const _hoisted_87 = { class: "ia-gantt-chip ia-gantt-chip--assignee" }
const _hoisted_88 = { class: "ia-delete-dialog" }
const _hoisted_89 = { class: "ia-delete-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["ia-content-row", { 'ia-content-row--split': _ctx.activeSubmission !== null }])
      }, [
        _createElementVNode("aside", {
          class: _normalizeClass(["ia-history-sidebar", { 'ia-history-sidebar--open': _ctx.sidebarOpen }])
        }, [
          _cache[50] || (_cache[50] = _createStaticVNode("<div class=\"ia-brand\" data-v-187129b4><div class=\"ia-brand-badge\" data-v-187129b4><img src=\"/icos/ot-transparente.png\" alt=\"ObraTycoon\" width=\"26\" height=\"26\" style=\"object-fit:contain;\" data-v-187129b4></div><div class=\"ia-brand-text\" data-v-187129b4><span class=\"ia-brand-name\" data-v-187129b4>Estagiario</span><span class=\"ia-brand-sub\" data-v-187129b4>ObraTycoon</span></div></div>", 1)),
          _createElementVNode("button", {
            class: "ia-new-chat",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startNewChat && _ctx.startNewChat(...args)))
          }, [...(_cache[39] || (_cache[39] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M12 5v14M5 12h14" })
            ], -1),
            _createTextVNode(" Novo chat ", -1)
          ]))]),
          _createElementVNode("div", _hoisted_2, [
            _cache[40] || (_cache[40] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "7"
              }),
              _createElementVNode("path", { d: "m21 21-4.3-4.3" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.historySearch) = $event)),
              type: "text",
              placeholder: "Buscar no histórico"
            }, null, 512), [
              [_vModelText, _ctx.historySearch]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "ia-history-label" }, "Histórico", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChats, (chat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: chat.id,
                class: _normalizeClass(["ia-history-item", { active: chat.id === _ctx.activeChatId }]),
                onClick: ($event: any) => (_ctx.selectChat(chat.id))
              }, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "ia-history-dot" }, null, -1)),
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(chat.title), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatHistoryTime(chat.updatedAt)) + " · " + _toDisplayString(chat.messages.length) + " msg", 1)
                ]),
                _createElementVNode("button", {
                  class: "ia-history-delete",
                  type: "button",
                  title: "Apagar chat",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteChat(chat.id)), ["stop"])
                }, [...(_cache[41] || (_cache[41] = [
                  _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]))], 8, _hoisted_8)
              ], 10, _hoisted_4))
            }), 128)),
            (_ctx.filteredChats.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Nenhum chat encontrado."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "ia-trash-toggle",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trashOpen = !_ctx.trashOpen))
            }, [
              _cache[45] || (_cache[45] = _createStaticVNode("<svg width=\"12\" height=\"12\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-187129b4><polyline points=\"3 6 5 6 21 6\" data-v-187129b4></polyline><path d=\"M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6\" data-v-187129b4></path><path d=\"M10 11v6M14 11v6\" data-v-187129b4></path><path d=\"M9 6V4h6v2\" data-v-187129b4></path></svg> Recentemente apagados ", 2)),
              (_ctx.trashedSessions.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.trashedSessions.length), 1))
                : _createCommentVNode("", true),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["ia-trash-chevron", { open: _ctx.trashOpen }]),
                width: "11",
                height: "11",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round"
              }, [...(_cache[44] || (_cache[44] = [
                _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
              ]))], 2))
            ]),
            (_ctx.trashOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.trashedSessions.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Nenhum chat apagado."))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trashedSessions, (chat) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: chat.id,
                      class: "ia-trash-item"
                    }, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(chat.title), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatHistoryTime(chat.updatedAt)), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: "ia-trash-restore",
                          type: "button",
                          title: "Restaurar",
                          onClick: ($event: any) => (_ctx.restoreChat(chat.id))
                        }, [...(_cache[46] || (_cache[46] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }),
                            _createElementVNode("path", { d: "M3 3v5h5" })
                          ], -1)
                        ]))], 8, _hoisted_17),
                        _createElementVNode("button", {
                          class: "ia-trash-purge",
                          type: "button",
                          title: "Apagar definitivamente",
                          onClick: ($event: any) => (_ctx.purgeChat(chat.id))
                        }, [...(_cache[47] || (_cache[47] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "18",
                              y1: "6",
                              x2: "6",
                              y2: "18"
                            }),
                            _createElementVNode("line", {
                              x1: "6",
                              y1: "6",
                              x2: "18",
                              y2: "18"
                            })
                          ], -1)
                        ]))], 8, _hoisted_18)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[49] || (_cache[49] = _createStaticVNode("<label class=\"ia-stt-label\" data-v-187129b4><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-187129b4><path d=\"M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z\" data-v-187129b4></path><path d=\"M19 10v2a7 7 0 0 1-14 0v-2\" data-v-187129b4></path><line x1=\"12\" y1=\"19\" x2=\"12\" y2=\"23\" data-v-187129b4></line><line x1=\"8\" y1=\"23\" x2=\"16\" y2=\"23\" data-v-187129b4></line></svg> Idioma do microfone </label>", 1)),
            _withDirectives(_createElementVNode("select", {
              class: "ia-stt-select",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sttLang) = $event))
            }, [...(_cache[48] || (_cache[48] = [
              _createStaticVNode("<option value=\"pt-BR\" data-v-187129b4>🇧🇷 Português (BR)</option><option value=\"pt-PT\" data-v-187129b4>🇵🇹 Português (PT)</option><option value=\"en-US\" data-v-187129b4>🇺🇸 English (US)</option><option value=\"en-GB\" data-v-187129b4>🇬🇧 English (UK)</option><option value=\"es-ES\" data-v-187129b4>🇪🇸 Español</option><option value=\"fr-FR\" data-v-187129b4>🇫🇷 Français</option><option value=\"de-DE\" data-v-187129b4>🇩🇪 Deutsch</option><option value=\"it-IT\" data-v-187129b4>🇮🇹 Italiano</option><option value=\"zh-CN\" data-v-187129b4>🇨🇳 中文</option><option value=\"ja-JP\" data-v-187129b4>🇯🇵 日本語</option>", 10)
            ]))], 512), [
              [_vModelSelect, _ctx.sttLang]
            ]),
            (!_ctx.sttSupported)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Microfone não suportado neste navegador."))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "ia-back-btn",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [...(_cache[51] || (_cache[51] = [
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
            ], -1),
            _createTextVNode(" Voltar ", -1)
          ]))]),
          _createElementVNode("button", {
            class: "ia-history-toggle",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sidebarOpen = true))
          }, [...(_cache[52] || (_cache[52] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
              }),
              _createElementVNode("line", {
                x1: "3",
                y1: "12",
                x2: "21",
                y2: "12"
              }),
              _createElementVNode("line", {
                x1: "3",
                y1: "18",
                x2: "21",
                y2: "18"
              })
            ], -1),
            _createTextVNode(" Histórico ", -1)
          ]))]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.canScrollUp && _ctx.messages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["ia-body", { 'ia-body--messages': _ctx.messages.length > 0 }]),
              ref: "messagesBodyRef",
              onScroll: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onBodyScroll && _ctx.onBodyScroll(...args)))
            }, [
              (_ctx.messages.length === 0)
                ? (_openBlock(), _createElementBlock("div", {
                    class: "ia-hero",
                    key: _ctx.ganttReportMode
                  }, [
                    (_ctx.ganttReportMode === 'offline')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[58] || (_cache[58] = _createStaticVNode("<div class=\"ia-welcome-avatar\" data-v-187129b4><svg width=\"40\" height=\"40\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-187129b4><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-187129b4></path><polyline points=\"14 2 14 8 20 8\" data-v-187129b4></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-187129b4></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-187129b4></line></svg></div><h1 class=\"ia-welcome-title\" data-v-187129b4>Relatório<br data-v-187129b4>de Obra</h1><p class=\"ia-hero-desc\" data-v-187129b4>Gere automaticamente um relatório semanal a partir do Gantt, sem precisar de IA.</p>", 3)),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _cache[54] || (_cache[54] = _createElementVNode("label", { class: "offline-report-label" }, "Projeto", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.offlineProjectId) = $event)),
                                class: "offline-report-select",
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.offlineError = ''))
                              }, [
                                _cache[53] || (_cache[53] = _createElementVNode("option", { value: "" }, "Selecionar projeto...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProjects, (p) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: p.id,
                                    value: p.id
                                  }, _toDisplayString(p.name), 9, _hoisted_26))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.offlineProjectId]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _cache[56] || (_cache[56] = _createElementVNode("label", { class: "offline-report-label" }, "Semana", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.offlineWeekOffset) = $event)),
                                class: "offline-report-select"
                              }, [...(_cache[55] || (_cache[55] = [
                                _createElementVNode("option", { value: -1 }, "Semana passada", -1),
                                _createElementVNode("option", { value: 0 }, "Semana atual", -1),
                                _createElementVNode("option", { value: 1 }, "Próxima semana", -1)
                              ]))], 512), [
                                [_vModelSelect, _ctx.offlineWeekOffset]
                              ])
                            ]),
                            (_ctx.offlineError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.offlineError), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "offline-report-btn",
                              type: "button",
                              disabled: !_ctx.offlineProjectId || _ctx.offlineGenerating,
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.generateOfflineReport && _ctx.generateOfflineReport(...args)))
                            }, [
                              (!_ctx.offlineGenerating)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[57] || (_cache[57] = [
                                    _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }, null, -1),
                                    _createElementVNode("polyline", { points: "14 2 14 8 20 8" }, null, -1),
                                    _createElementVNode("line", {
                                      x1: "12",
                                      y1: "18",
                                      x2: "12",
                                      y2: "12"
                                    }, null, -1),
                                    _createElementVNode("line", {
                                      x1: "9",
                                      y1: "15",
                                      x2: "15",
                                      y2: "15"
                                    }, null, -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_31)),
                              _createTextVNode(" " + _toDisplayString(_ctx.offlineGenerating ? 'Gerando...' : 'Gerar Relatório'), 1)
                            ], 8, _hoisted_29)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[62] || (_cache[62] = _createElementVNode("div", { class: "ia-welcome-avatar" }, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "Estagiário",
                              width: "52",
                              height: "52",
                              style: {"object-fit":"contain"}
                            })
                          ], -1)),
                          _cache[63] || (_cache[63] = _createElementVNode("h1", { class: "ia-welcome-title" }, [
                            _createTextVNode("Como posso"),
                            _createElementVNode("br"),
                            _createTextVNode("ajudar?")
                          ], -1)),
                          _cache[64] || (_cache[64] = _createElementVNode("p", { class: "ia-hero-desc" }, "Sou o Estagiário, seu assistente para gestão de obras. Tire dúvidas, analise dados e automatize tarefas do canteiro.", -1)),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("button", {
                              class: "ia-suggestion-chip",
                              type: "button",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.fillSuggestion('Criar relatório de hoje: ')))
                            }, [...(_cache[59] || (_cache[59] = [
                              _createElementVNode("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                              ], -1),
                              _createTextVNode(" Criar relatório de hoje ", -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "ia-suggestion-chip",
                              type: "button",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.fillSuggestion('Adicionar ao planejamento: ')))
                            }, [...(_cache[60] || (_cache[60] = [
                              _createElementVNode("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "4",
                                  width: "18",
                                  height: "18",
                                  rx: "2"
                                }),
                                _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18M12 14v4M10 16h4" })
                              ], -1),
                              _createTextVNode(" Adicionar atividade ao planejamento ", -1)
                            ]))]),
                            _createElementVNode("button", {
                              class: "ia-suggestion-chip",
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.fillSuggestion('Ver o último relatório de ')))
                            }, [...(_cache[61] || (_cache[61] = [
                              _createElementVNode("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("circle", {
                                  cx: "11",
                                  cy: "11",
                                  r: "7"
                                }),
                                _createElementVNode("path", { d: "M21 21l-4.3-4.3" })
                              ], -1),
                              _createTextVNode(" Ver um relatório ", -1)
                            ]))])
                          ])
                        ], 64))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: msg.id,
                        class: _normalizeClass(["ia-msg", 'ia-msg--' + msg.role])
                      }, [
                        (msg.role === 'assistant')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[66] || (_cache[66] = _createElementVNode("div", { class: "ia-bot-avatar" }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  alt: "Estagiário",
                                  width: "24",
                                  height: "24",
                                  style: {"object-fit":"contain"}
                                })
                              ], -1)),
                              _createElementVNode("div", _hoisted_34, [
                                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "ia-msg-name" }, [
                                  _createTextVNode("Estagiário "),
                                  _createElementVNode("span", { class: "ia-msg-tag" }, "IA")
                                ], -1)),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(msg.content), 1)
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(msg.content), 1))
                      ], 2))
                    }), 128)),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[67] || (_cache[67] = [
                          _createStaticVNode("<div class=\"ia-bot-avatar\" data-v-187129b4><img src=\"" + _imports_0 + "\" alt=\"Estagiário\" width=\"24\" height=\"24\" style=\"object-fit:contain;\" data-v-187129b4></div><div class=\"ia-msg-body\" data-v-187129b4><div class=\"ia-msg-name\" data-v-187129b4>Estagiário <span class=\"ia-msg-tag\" data-v-187129b4>IA</span></div><div class=\"ia-typing-dots\" aria-label=\"Digitando...\" data-v-187129b4><span data-v-187129b4></span><span data-v-187129b4></span><span data-v-187129b4></span></div></div>", 2)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]))
            ], 34),
            (_ctx.canScrollDown && _ctx.messages.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.chatState === 'confirm')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("button", {
                    class: "ia-action-btn ia-action-btn--save",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.confirmSave && _ctx.confirmSave(...args)))
                  }, [...(_cache[68] || (_cache[68] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                    ], -1),
                    _createTextVNode(" Sim, salvar ", -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "ia-action-btn ia-action-btn--edit",
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.confirmEdit && _ctx.confirmEdit(...args)))
                  }, [...(_cache[69] || (_cache[69] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" }),
                      _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" })
                    ], -1),
                    _createTextVNode(" Não, editar ", -1)
                  ]))])
                ]))
              : (_ctx.chatState === 'gantt-confirm')
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("button", {
                      class: "ia-action-btn ia-action-btn--save",
                      type: "button",
                      disabled: _ctx.ganttSaving,
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.confirmAddGanttTasks && _ctx.confirmAddGanttTasks(...args)))
                    }, [
                      _cache[70] || (_cache[70] = _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.ganttSaving ? 'Adicionando…' : 'Sim, adicionar ao planejamento'), 1)
                    ], 8, _hoisted_42),
                    _createElementVNode("button", {
                      class: "ia-action-btn ia-action-btn--back",
                      type: "button",
                      disabled: _ctx.ganttSaving,
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.cancelGanttTasks && _ctx.cancelGanttTasks(...args)))
                    }, [...(_cache[71] || (_cache[71] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1),
                      _createTextVNode(" Cancelar ", -1)
                    ]))], 8, _hoisted_43)
                  ]))
                : (_ctx.chatState === 'view')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("button", {
                        class: "ia-action-btn ia-action-btn--pdf",
                        type: "button",
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.exportPdf && _ctx.exportPdf(...args)))
                      }, [...(_cache[72] || (_cache[72] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" }),
                          _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                        ], -1),
                        _createTextVNode(" Gerar PDF ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "ia-action-btn ia-action-btn--edit",
                        type: "button",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.editActiveSubmission && _ctx.editActiveSubmission(...args)))
                      }, [...(_cache[73] || (_cache[73] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" }),
                          _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" })
                        ], -1),
                        _createTextVNode(" Editar relatório ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "ia-action-btn ia-action-btn--back",
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.resetToIdle && _ctx.resetToIdle(...args)))
                      }, [...(_cache[74] || (_cache[74] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                        ], -1),
                        _createTextVNode(" Voltar para IA ", -1)
                      ]))])
                    ]))
                  : (_ctx.chatState === 'filling' && !_ctx.isWriteMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: opt.value,
                            class: "ia-opt-btn",
                            type: "button",
                            onClick: ($event: any) => (_ctx.handleOptionClick(opt))
                          }, _toDisplayString(opt.label), 9, _hoisted_46))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "ia-write-btn",
                          type: "button",
                          onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.enterWriteMode && _ctx.enterWriteMode(...args)))
                        }, [...(_cache[75] || (_cache[75] = [
                          _createElementVNode("svg", {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" }),
                            _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" })
                          ], -1),
                          _createTextVNode(" Escrever ", -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
            (_ctx.showTextarea)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("input", {
                    ref: "fileInputRef",
                    type: "file",
                    multiple: "",
                    accept: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                    style: {"display":"none"},
                    onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                  }, null, 544),
                  _createElementVNode("button", {
                    class: "ia-tool-btn",
                    type: "button",
                    title: "Anexar arquivo",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.fileInputRef?.click()))
                  }, [...(_cache[76] || (_cache[76] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                    ], -1)
                  ]))]),
                  (_ctx.isRecording || !_ctx.textareaFocused)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["ia-tool-btn", { 'ia-tool-btn--recording': _ctx.isRecording }]),
                        type: "button",
                        title: _ctx.isRecording ? 'Parar gravação' : 'Gravar áudio',
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.toggleRecording && _ctx.toggleRecording(...args)))
                      }, [
                        (!_ctx.isRecording)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_49, [...(_cache[77] || (_cache[77] = [
                              _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }, null, -1),
                              _createElementVNode("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, null, -1),
                              _createElementVNode("line", {
                                x1: "12",
                                y1: "19",
                                x2: "12",
                                y2: "23"
                              }, null, -1),
                              _createElementVNode("line", {
                                x1: "8",
                                y1: "23",
                                x2: "16",
                                y2: "23"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_50, [...(_cache[78] || (_cache[78] = [
                              _createElementVNode("rect", {
                                x: "3",
                                y: "3",
                                width: "18",
                                height: "18",
                                rx: "2"
                              }, null, -1)
                            ]))]))
                      ], 10, _hoisted_48))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("textarea", {
                    ref: "textareaRef",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.inputText) = $event)),
                    class: "ia-textarea",
                    placeholder: _ctx.isRecording ? 'Gravando áudio...' : _ctx.questionPlaceholder,
                    disabled: _ctx.isRecording,
                    rows: "1",
                    onKeydown: _cache[26] || (_cache[26] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["exact","prevent"]), ["enter"])),
                    onInput: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.autoResize && _ctx.autoResize(...args))),
                    onFocus: _cache[28] || (_cache[28] = ($event: any) => (_ctx.textareaFocused = true)),
                    onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.textareaFocused = false))
                  }, null, 40, _hoisted_51), [
                    [_vModelText, _ctx.inputText]
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["ia-send-btn", { 'ia-send-btn--active': _ctx.inputText.trim() || _ctx.attachments.length > 0 }]),
                    type: "button",
                    disabled: !_ctx.inputText.trim() && _ctx.attachments.length === 0,
                    title: "Enviar (Enter)",
                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                  }, [...(_cache[79] || (_cache[79] = [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M5 12h14M13 6l6 6-6 6" })
                    ], -1)
                  ]))], 10, _hoisted_52)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showTextarea)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.attachments.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (f, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "ia-attachment"
                          }, [
                            _cache[81] || (_cache[81] = _createElementVNode("svg", {
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                            ], -1)),
                            _createElementVNode("span", null, _toDisplayString(f.name), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "ia-attachment-remove",
                              onClick: ($event: any) => (_ctx.removeAttachment(i))
                            }, [...(_cache[80] || (_cache[80] = [
                              _createElementVNode("svg", {
                                width: "11",
                                height: "11",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5"
                              }, [
                                _createElementVNode("line", {
                                  x1: "18",
                                  y1: "6",
                                  x2: "6",
                                  y2: "18"
                                }),
                                _createElementVNode("line", {
                                  x1: "6",
                                  y1: "6",
                                  x2: "18",
                                  y2: "18"
                                })
                              ], -1)
                            ]))], 8, _hoisted_54)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isRecording)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _cache[82] || (_cache[82] = _createElementVNode("span", { class: "ia-rec-dot" }, null, -1)),
                        _createElementVNode("span", null, "Gravando... " + _toDisplayString(_ctx.recordingTime) + "s", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "ia-rec-cancel",
                          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.cancelRecording && _ctx.cancelRecording(...args)))
                        }, "Cancelar")
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _cache[83] || (_cache[83] = _createElementVNode("p", { class: "ia-disclaimer" }, "ObraTycoon IA pode cometer erros. Verifique informações importantes.", -1))
          ])
        ]),
        (_ctx.activeSubmission !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _cache[85] || (_cache[85] = _createElementVNode("div", { class: "ia-panel-header-title" }, [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" }),
                    _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                  ]),
                  _createElementVNode("span", null, "Rascunho de Relatório")
                ], -1)),
                _createElementVNode("button", {
                  class: "ia-panel-close",
                  type: "button",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
                }, [...(_cache[84] || (_cache[84] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _cache[86] || (_cache[86] = _createElementVNode("label", { class: "ia-panel-label" }, "Título", -1)),
                  _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.activeSubmission.title || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[87] || (_cache[87] = _createElementVNode("label", { class: "ia-panel-label" }, "Categoria", -1)),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["ia-panel-badge", 'ia-panel-badge--' + _ctx.activeSubmission.category])
                      }, _toDisplayString(_ctx.categoryLabel(_ctx.activeSubmission.category)), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _cache[88] || (_cache[88] = _createElementVNode("label", { class: "ia-panel-label" }, "Data", -1)),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.formatDate(_ctx.activeSubmission.reportDate)), 1)
                  ])
                ]),
                (_ctx.activeSubmission.attraction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _cache[89] || (_cache[89] = _createElementVNode("label", { class: "ia-panel-label" }, "Frente de trabalho", -1)),
                      _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.activeSubmission.attraction), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeSubmission.collaborators.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _cache[90] || (_cache[90] = _createElementVNode("label", { class: "ia-panel-label" }, "Colaboradores", -1)),
                      _createElementVNode("div", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSubmission.collaborators, (name) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: name,
                            class: "ia-panel-tag"
                          }, _toDisplayString(name), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeSubmission.activities.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _cache[92] || (_cache[92] = _createElementVNode("label", { class: "ia-panel-label" }, "Atividades", -1)),
                      _createElementVNode("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSubmission.activities, (act) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: act.id,
                            class: "ia-panel-list-item"
                          }, [
                            _cache[91] || (_cache[91] = _createElementVNode("span", { class: "ia-panel-list-dot" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(act.description), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeSubmission.tools.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _cache[94] || (_cache[94] = _createElementVNode("label", { class: "ia-panel-label" }, "Ferramentas / EPI", -1)),
                      _createElementVNode("div", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSubmission.tools, (tool) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tool.id,
                            class: "ia-panel-list-item"
                          }, [
                            _cache[93] || (_cache[93] = _createElementVNode("span", { class: "ia-panel-list-dot" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(tool.text), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeSubmission.observations.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _cache[96] || (_cache[96] = _createElementVNode("label", { class: "ia-panel-label" }, "Observações", -1)),
                      _createElementVNode("div", _hoisted_75, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSubmission.observations, (obs) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: obs.id,
                            class: "ia-panel-list-item"
                          }, [
                            _cache[95] || (_cache[95] = _createElementVNode("span", { class: "ia-panel-list-dot" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(obs.text), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_76, [
                  _cache[97] || (_cache[97] = _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "7",
                      r: "4"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.activeSubmission.author.name), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ganttPanelVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _cache[99] || (_cache[99] = _createElementVNode("div", { class: "ia-panel-header-title" }, [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "4",
                      width: "18",
                      height: "18",
                      rx: "2"
                    }),
                    _createElementVNode("path", { d: "M16 2v4M8 2v4M3 10h18" })
                  ]),
                  _createElementVNode("span", null, "Atividades para o Planejamento")
                ], -1)),
                _createElementVNode("button", {
                  class: "ia-panel-close",
                  type: "button",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.cancelGanttTasks && _ctx.cancelGanttTasks(...args)))
                }, [...(_cache[98] || (_cache[98] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _cache[100] || (_cache[100] = _createElementVNode("label", { class: "ia-panel-label" }, "Projeto", -1)),
                  _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.ganttTargetProjectName || '—'), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ganttTasksByArea, (grp) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: grp.area,
                    class: "ia-panel-field"
                  }, [
                    _createElementVNode("label", _hoisted_82, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_83, [...(_cache[101] || (_cache[101] = [
                        _createElementVNode("rect", {
                          x: "3",
                          y: "3",
                          width: "7",
                          height: "7"
                        }, null, -1),
                        _createElementVNode("rect", {
                          x: "14",
                          y: "3",
                          width: "7",
                          height: "7"
                        }, null, -1),
                        _createElementVNode("rect", {
                          x: "3",
                          y: "14",
                          width: "7",
                          height: "7"
                        }, null, -1),
                        _createElementVNode("rect", {
                          x: "14",
                          y: "14",
                          width: "7",
                          height: "7"
                        }, null, -1)
                      ]))])),
                      _createTextVNode(" " + _toDisplayString(grp.area), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.tasks, (t, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: grp.area + '-' + i,
                        class: "ia-gantt-task"
                      }, [
                        _createElementVNode("div", _hoisted_84, _toDisplayString(t.title), 1),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["ia-gantt-chip", { 'ia-gantt-chip--nodate': !t.startDate }])
                          }, _toDisplayString(t.startDate ? _ctx.formatDate(t.startDate) : 'Data não informada'), 3),
                          _createElementVNode("span", _hoisted_86, _toDisplayString(t.durationDays) + " " + _toDisplayString(t.durationDays > 1 ? 'dias' : 'dia'), 1),
                          _createElementVNode("span", _hoisted_87, _toDisplayString(t.assigneeName || _ctx.currentUserName), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                }), 128)),
                _cache[102] || (_cache[102] = _createElementVNode("p", { class: "ia-gantt-note" }, "Áreas que ainda não existirem serão criadas como grupos no Gantt. Atividades sem data entram na lista \"Sem data definida\" do planejamento.", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeSubmission !== null || _ctx.ganttPanelVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "ia-panel-backdrop",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.activeSubmission !== null ? _ctx.closePanel() : _ctx.cancelGanttTasks()))
            }))
          : _createCommentVNode("", true),
        (_ctx.sidebarOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "ia-sidebar-backdrop",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.sidebarOpen = false))
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.deletePendingId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "ia-delete-backdrop",
            onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (_ctx.deletePendingId = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_88, [
              _cache[103] || (_cache[103] = _createElementVNode("div", { class: "ia-delete-icon" }, [
                _createElementVNode("svg", {
                  width: "22",
                  height: "22",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                  _createElementVNode("path", { d: "M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" }),
                  _createElementVNode("path", { d: "M10 11v6M14 11v6" }),
                  _createElementVNode("path", { d: "M9 6V4h6v2" })
                ])
              ], -1)),
              _cache[104] || (_cache[104] = _createElementVNode("p", { class: "ia-delete-title" }, "Deseja mesmo apagar este chat?", -1)),
              _cache[105] || (_cache[105] = _createElementVNode("p", { class: "ia-delete-sub" }, "Ele será movido para \"Recentemente apagados\" e poderá ser restaurado.", -1)),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("button", {
                  class: "ia-delete-cancel",
                  type: "button",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.deletePendingId = null))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "ia-delete-confirm",
                  type: "button",
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                }, "Apagar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}